module.exports = __webpack_public_path__ + "img/slider1.cbcc50c3.jpg";